import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { GoogleSheetFacade } from '@mode/dataset/contract';
import { GoogleSheetUploadFacade } from '@mode/dataset/google/contract';
import { AccountFacade } from '@mode/accounts/contract';
import { UploadSheetDialogService } from '../upload-sheet-dialog/upload-sheet-dialog.service';

interface SimpleReport {
  token: string;
  layout: string;
}

@Injectable()
export class UploadSheetService implements GoogleSheetUploadFacade {
  constructor(
    private _accountFacade: AccountFacade,
    private _googleSheetFacade: GoogleSheetFacade,
    private _http: HttpClient,
    private _uploadSheetDialogService: UploadSheetDialogService
  ) {}

  async launchDialog() {
    const accountId = (await firstValueFrom(this._accountFacade.currentOrg$)).username;
    const { layout, token } = await firstValueFrom(
      this._http.get<SimpleReport>(`/api/${accountId}/reports/new?only=token,layout`)
    );

    this._uploadSheetDialogService.open({
      confirmAction: ({ tab, name, description, spreadsheetId, worksheetId, url }) => {
        this._googleSheetFacade.createGoogleSheetDataset({
          tab,
          name,
          description,
          spreadsheetId,
          worksheetId,
          url,
          accountId,
          token,
          layout,
        });
      },
    });
  }
}
